module.exports = __webpack_public_path__ + "static/media/IMG_20200902_200201_306_tn.d28c3cfd.jpg";